import * as actions from './actions';

export const selectActiveUsers = store => store.users.filter(user => user.status === 'active');
export const selectDisabledUsers = store =>
    store.users.filter(user => user.status === 'disabled' || user.status === 'revoked');
export const selectPendingUsers = store => store.users.filter(user => user.status === 'pending');

const initialState = () => {
    return {
        error: null,
        invitation: null,
        isBusy: false,
        items: [],
        existingBrokerId: null,
        isUserInOtherBrokerage: false,
        signup: {}
    };
};

export default function(state = initialState(), action) {
    switch (action.type) {
        case actions.FETCH_USERS: {
            return {
                ...state,
                isBusy: false,
                error: null
            };
        }

        case actions.FETCH_USERS_SUCCESS: {
            return {
                ...state,
                isBusy: false,
                items: action.value,
                error: null
            };
        }

        case actions.FETCH_LOCKED_USERS: {
            return {
                ...state,
                isBusy: false,
                error: null
            };
        }

        case actions.FETCH_LOCKED_USERS_SUCCESS: {
            return {
                ...state,
                isBusy: false,
                lockedUsers: action.value,
                error: null
            };
        }

        case actions.FETCH_USERS_FAILURE: {
            return {
                ...state,
                isBusy: false,
                error: action.value
            };
        }

        case actions.INVITE_USER: {
            const invitation = action.value;
            return {
                ...state,
                isBusy: true,
                error: null,
                invitation: invitation
            };
        }

        case actions.INVITE_USER_SUCCESS: {
            const invitation = action.value;
            return {
                ...state,
                isBusy: false,
                error: null,
                invitation: null
            };
        }

        case actions.INVITE_USER_FAILURE: {
            const { invitation, error } = action.value;
            return {
                ...state,
                isBusy: false,
                error: error,
                invitation: invitation
            };
        }

        case actions.CLEAR_ERROR: {
            return {
                ...state,
                error: null
            };
        }

        case actions.CANCEL_INVITATION: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.CANCEL_INVITATION_SUCCESS: {
            return {
                ...state,
                isBusy: false,
                error: null
            };
        }

        case actions.CANCEL_INVITATION_FAILURE: {
            const { user, error } = action.value;
            return {
                ...state,
                isBusy: false,
                error
            };
        }

        case actions.CLEAR_INVITATION: {
            return {
                ...state,
                invitation: null
            };
        }

        case actions.DISABLE_USER: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.DISABLE_USER_SUCCESS: {
            return {
                ...state,
                isBusy: false,
                error: null
            };
        }

        case actions.DISABLE_USER_FAILURE: {
            const { user, error } = action.value;
            return {
                ...state,
                isBusy: false,
                error
            };
        }

        case actions.ENABLE_USER: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.ENABLE_USER_SUCCESS: {
            return {
                ...state,
                isBusy: false,
                error: null
            };
        }

        case actions.ENABLE_USER_FAILURE: {
            const { error } = action.value;
            return {
                ...state,
                isBusy: false,
                error
            };
        }

        case actions.RESEND_INVITATION: {
            const { user } = action.value;
            return {
                ...state,
                isBusy: true,
                error: null,
                invitation: null
            };
        }

        case actions.RESEND_INVITATION_SUCCESS: {
            const { user } = action.value;
            return {
                ...state,
                isBusy: false,
                error: null,
                invitation: null
            };
        }

        case actions.RESEND_INVITATION_FAILURE: {
            const { user, error } = action.value;
            return {
                ...state,
                isBusy: false,
                error: error,
                inivation: {
                    email: user.email,
                    status: 'error',
                    statusMessage: error.message
                }
            };
        }

        case actions.REVOKE_USER: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.REVOKE_USER_SUCCESS: {
            return {
                ...state,
                isBusy: false,
                error: null
            };
        }

        case actions.REVOKE_USER_FAILURE: {
            const { user, error } = action.value;
            return {
                ...state,
                isBusy: false,
                error
            };
        }

        case actions.SAVE_USER: {
            return {
                ...state,
                isBusy: true,
                error: false
            };
        }

        case actions.SAVE_USER_SUCCESS: {
            return {
                ...state,
                isBusy: false,
                error: false
            };
        }

        case actions.SAVE_USER_FAILURE: {
            const { user, error } = action.value;
            return {
                ...state,
                isBusy: false,
                error
            };
        }

        case actions.CHANGE_BROKERAGE: {
            return {
                ...state,
                isBusy: true,
                error: false
            };
        }

        case actions.CHANGE_BROKERAGE_SUCCESS: {
            return {
                ...state,
                isBusy: false,
                error: false,
                invitation: null
            };
        }

        case actions.CHANGE_BROKERAGE_FAILURE: {
            const { user, error } = action.value;
            return {
                ...state,
                isBusy: false,
                error
            };
        }

        case actions.SIGNUP_USER: {
            const email = action.value;
            return {
                ...state,
                isBusy: true,
                error: null,
                email: email
            };
        }

        case actions.SIGNUP_USER_SUCCESS: {
            const email = action.value;
            return {
                ...state,
                isBusy: false,
                error: null,
                signup: {
                    ...state.signup,
                    email,
                    status: false
                }
            };
        }

        case actions.SIGNUP_USER_FAILED: {
            const { payload: { email, error } } = action;
            return {
                ...state,
                isBusy: false,
                error: error,
                signup: {
                    ...state.signup,
                    email,
                    statusMessage: error.message,
                    status: true
                }
            };
        }

        case actions.SIGNUP_USER_EXIST: {
            const { value: email } = action;
            return {
                ...state,
                isBusy: false,
                error: null,
                signup: {
                    ...state.signup,
                    statusMessage: `${email} already exists`,
                    email,
                    status: true
                }
            };
        }

        case actions.SEND_REQUEST_ACCESS: {
            return {
                ...state,
                isBusy: true,
                error: false
            };
        }

        case actions.SEND_REQUEST_ACCESS_SUCCESS: {
            const { value: email } = action
            return {
                ...state,
                isBusy: false,
                error: false,
                signup: {
                    ...state.signup,
                    email,
                    requestStatus: true,
                    status: true
                }
            };
        }

        case actions.SEND_REQUEST_ACCESS_FAILED: {
            const { value: email } = action;
            const { error } = action.value;
            return {
                ...state,
                isBusy: false,
                error,
                signup: {
                    ...state.signup,
                    requestStatus: false,
                    status: true
                }
            };
        }

        default:
            return state;
    }
}
